import { render, staticRenderFns } from "./InstructionTextAreaDialog.vue?vue&type=template&id=61afcea1"
import script from "./InstructionTextAreaDialog.vue?vue&type=script&lang=js"
export * from "./InstructionTextAreaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports